{
    "rfc": "BPP2207121N2",
    "result_model": {
        "score_code": "B",
        "score": 626.8393983094942,
        "requested_amount": null,
        "requested_term": null,
        "authorized_amount": 2000000,
        "authorized_term": 0,
        "interest_rate": 29,
        "date_model": "2026-02-09 18:21:48.896156",
        "days_validity_model": 0,
        "id_model": "ab152571-f3bf-4f6b-b3bf-e3e8b86e0449"
    },
    "general_company_details": {
        "annual_sales_invoiced": 308818088.71,
        "annual_revenues_invoiced": 308818088.71,
        "number_employees": 4,
        "score_company": 363,
        "score_syntage": 647,
        "status_blacklists": null,
        "seniority": 3.5811088295687883,
        "predominant_activity": "Clubes deportivos del sector privado",
        "annual_purchases_invoiced": 307341230.18,
        "annual_expenses_invoiced": 306875248.82,
        "monthly_payroll": 300044987.449167,
        "declared_income_loss": 0,
        "bc_score": 745,
        "blacklists": 0,
        "compliance_opinion": "negative",
        "equity": 323402019,
        "payment_capacity": 300286338.278012
    },
    "analysis_categories": {
        "sales_purchases": 80.05782621527256,
        "customers_suppliers_ps": 76.58367611816942,
        "payroll_employees": 100,
        "financial_declared": 74.72904120844375,
        "accredited_bureau": 96.68387671297255,
        "bureau_person": 84.65188677776324,
        "csf_others": 0,
        "flow_cancellation_ratios": 78.76585910694499,
        "total": 82.00396819187047
    },
    "abortive_status": {
        "sales": {
            "label": "Ventas",
            "sales_volume": {
                "label": "Ventas Anuales",
                "value": true
            },
            "government_sales": {
                "label": "Ventas Gubernamentales",
                "value": false
            },
            "show_menu": true
        },
        "seniority": {
            "label": "Antigüedad",
            "seniority": {
                "label": "Antigüedad",
                "value": false
            },
            "show_menu": true
        },
        "payment_capacity": {
            "label": "Capacidad Pago",
            "payment_capacity": {
                "label": "Capacidad de Pago",
                "value": true
            },
            "show_menu": true
        }
    },
    "review_status": {
        "sales": {
            "label": "Ventas",
            "sales_volume": {
                "label": "Ventas Anuales",
                "value": true
            },
            "income_variation": {
                "label": "Variación de Ventas",
                "value": false
            },
            "show_menu": true
        },
        "seniority": {
            "label": "Antigüedad",
            "seniority_activity": {
                "label": "Antigüedad Actividad",
                "value": false
            },
            "show_menu": true
        },
        "tax_return": {
            "label": "Declaración",
            "equity": {
                "label": "Capital Contable",
                "value": false
            },
            "tax_return_exist": {
                "label": "Declaraciones Emitidas",
                "value": false
            },
            "show_menu": true
        },
        "concentration": {
            "label": "Concentración Cliente",
            "client_concentration": {
                "label": "Concentración Cliente",
                "value": false
            },
            "top_2_client_concentration": {
                "label": "Concentración Clientes",
                "value": false
            },
            "show_menu": true
        },
        "credit_bureau": {
            "label": "Histórico Burós",
            "credit_bureau_history": {
                "label": "Histórico Burós",
                "value": false
            },
            "show_menu": true
        },
        "tax_compliance": {
            "label": "Opinion de cumplimiento",
            "tax_compliance": {
                "label": "Opinión de Cumplimiento",
                "value": true
            },
            "show_menu": true
        },
        "shareholder_or_pfae_age": {
            "label": "Edad",
            "shareholder_or_pfae_age": {
                "label": "Edad Aval",
                "value": false
            },
            "show_menu": true
        },
        "credit_bureau_accredited": {
            "label": "Buró Acreditado",
            "mops_matrix": {
                "label": "Matriz MOPs",
                "value": false
            },
            "fiscal_credits": {
                "label": "Créditos Fiscales",
                "value": false
            },
            "overdue_balance": {
                "label": "Saldo Vencido",
                "value": false
            },
            "percentage_mops_1": {
                "label": "Porcentaje MOPs 1",
                "value": false
            },
            "credit_bureau_history": {
                "label": "Histórico Buró PM",
                "value": false
            },
            "debt_restructuring_bankruptcies_dations": {
                "label": "Quitas, Quebrantos, Daciones",
                "value": false
            },
            "show_menu": true
        },
        "fiscal_status_certificate": {
            "zone": {
                "label": "CP. Excluido",
                "value": false
            },
            "label": "CSF",
            "non_preponderant_activity_excluded": {
                "label": "Actividad Excluida",
                "value": false
            },
            "show_menu": true
        },
        "credit_bureau_shareholder_or_pf": {
            "label": "Buró Aval / PFAE",
            "mops_matrix": {
                "label": "Matriz MOPs",
                "value": false
            },
            "overdue_balance": {
                "label": "Saldo Vencido",
                "value": false
            },
            "percentage_mops_1": {
                "label": "Porcentaje MOPs 1",
                "value": false
            },
            "show_menu": true
        }
    },
    "client_features": {
        "advance_payment": 0.1,
        "authorized_credit_lines_utilization_percentage_pf": null,
        "average_volatility": 0.3361866681387071,
        "company_first_financial_credit_age_months": 17,
        "credit_bureau_inquiries_last_3_months": 0,
        "first_credit_card_age_months": 140,
        "guarantor_max_mop_last_3_years": 1,
        "liquidity": 1.3864919355345913,
        "main_economic_activity_seniority": 1,
        "majority_shareholder_participation_percentage": 0.4,
        "region": "METROPOLITANA",
        "scian_code": "713941",
        "scian_code_3_digits": "713",
        "sector": "71",
        "sector_description": "Servicios de esparcimiento culturales y deportivos, y otros servicios recreativos",
        "macrosector": "Servicios"
    },
    "result_external_model": {
        "model_code": "mercader_parametrico_pf",
        "version": "1.0",
        "id_model": "example",
        "date_model": "2026-10-05 12:00:00",
        "result": "APPROVED",
        "score": 84.46,
        "min_score": 75,
        "points": 47.3,
        "max_points": 56,
        "blocks": {
            "Capacidad": {
                "points": 15,
                "max_points": 15
            },
            "Buró": {
                "points": 21,
                "max_points": 25
            },
            "Solicitud": {
                "points": 7.8,
                "max_points": 10.5
            },
            "Perfil": {
                "points": 0.5,
                "max_points": 1
            },
            "Ubicación": {
                "points": 3,
                "max_points": 4.5
            }
        },
        "payment_capacity": {
            "monthly_income": 522000,
            "monthly_outcome": 157000,
            "monthly_profit": 365000,
            "bureau_payments": 39900,
            "remaining": 325100,
            "asset_price": 1200000,
            "advance_pct": 0.2,
            "advance_amount": 240000,
            "amount_to_finance": 960000,
            "term": 36,
            "annual_rate": 0.25,
            "vat": 0.16,
            "rent_without_vat": 38169.43,
            "rent_with_vat": 44276.54,
            "payment_times": 7.34,
            "min_payment_times": 2.5,
            "max_supported_rent": 130040
        },
        "bureau": {
            "source": "PFAE",
            "credits": {
                "1": {
                    "grantor": "BANCO",
                    "grantor_type": "BANCO",
                    "credit_type": "REVOLVENTE",
                    "credit_type_code": null,
                    "active": true,
                    "balance": 45000,
                    "monthly_payment": 2500,
                    "payment_source": "REPORTED",
                    "worst_mop": 1,
                    "debt_relief": false,
                    "opened_at": null
                },
                "2": {
                    "grantor": "BANCO",
                    "grantor_type": "BANCO",
                    "credit_type": "PAGOS FIJOS",
                    "credit_type_code": null,
                    "active": true,
                    "balance": 491000,
                    "monthly_payment": 14800,
                    "payment_source": "REPORTED",
                    "worst_mop": 1,
                    "debt_relief": false,
                    "opened_at": null
                },
                "3": {
                    "grantor": "ARRENDADORA",
                    "grantor_type": "ARRENDADORA",
                    "credit_type": "PAGOS FIJOS",
                    "credit_type_code": null,
                    "active": true,
                    "balance": 606000,
                    "monthly_payment": 22000,
                    "payment_source": "REPORTED",
                    "worst_mop": 1,
                    "debt_relief": false,
                    "opened_at": null
                },
                "4": {
                    "grantor": "OTRA FINANCIERA",
                    "grantor_type": "OTRA FINANCIERA",
                    "credit_type": "REVOLVENTE",
                    "credit_type_code": null,
                    "active": true,
                    "balance": 12000,
                    "monthly_payment": 600,
                    "payment_source": "REPORTED",
                    "worst_mop": 2,
                    "debt_relief": false,
                    "opened_at": null
                },
                "5": {
                    "grantor": "BANCO",
                    "grantor_type": "BANCO",
                    "credit_type": "REVOLVENTE",
                    "credit_type_code": null,
                    "active": false,
                    "balance": 0,
                    "monthly_payment": 0,
                    "payment_source": null,
                    "worst_mop": 1,
                    "debt_relief": false,
                    "opened_at": null
                }
            },
            "total_credits": 5,
            "active_credits": 4,
            "worst_mop": 2,
            "debt_relief": false,
            "total_balance": 1154000
        },
        "scorecard": {
            "payment_times": {
                "order": 1,
                "block": "Capacidad",
                "label": "Veces pago",
                "source": "Formulario + buró + cotizador",
                "value": 7.34,
                "value_label": "7.34x",
                "bin": "b1",
                "bin_label": "Desde 2.5x",
                "points": 15,
                "max_points": 15,
                "imputed": false,
                "imputed_reason": null
            },
            "credit_behavior": {
                "order": 2,
                "block": "Buró",
                "label": "Comportamiento crediticio",
                "source": "Buró PFAE",
                "value": "MOP_02",
                "value_label": "Peor MOP 02",
                "bin": "MOP_02",
                "bin_label": "AL CORRIENTE CON ATRASOS OCASIONALES",
                "points": 12,
                "max_points": 15,
                "imputed": false,
                "imputed_reason": null
            },
            "funding_sources": {
                "order": 3,
                "block": "Buró",
                "label": "Fuentes de financiamiento",
                "source": "Buró PFAE",
                "value": 4,
                "value_label": "4 créditos activos",
                "bin": "DE_3_A_5",
                "bin_label": "DE 3 A 5",
                "points": 4,
                "max_points": 5,
                "imputed": false,
                "imputed_reason": null
            },
            "funding_types": {
                "order": 4,
                "block": "Buró",
                "label": "Tipos de fuentes de fondeo",
                "source": "Buró PFAE",
                "value": "BANCO",
                "value_label": "2 de 4 activos",
                "bin": "BANCO",
                "bin_label": "EN SU MAYORÍA BANCOS",
                "points": 5,
                "max_points": 5,
                "imputed": false,
                "imputed_reason": null
            },
            "advance_payment": {
                "order": 5,
                "block": "Solicitud",
                "label": "Enganche",
                "source": "Cotizador",
                "value": 0.2,
                "value_label": "20%",
                "bin": "b20",
                "bin_label": "Desde 20%",
                "points": 3,
                "max_points": 3,
                "imputed": false,
                "imputed_reason": null
            },
            "amount_to_finance": {
                "order": 6,
                "block": "Solicitud",
                "label": "Monto a financiar",
                "source": "Cotizador",
                "value": 960000,
                "value_label": "$960,000",
                "bin": "b0",
                "bin_label": "Menor a $1M",
                "points": 0,
                "max_points": 2,
                "imputed": false,
                "imputed_reason": null
            },
            "term": {
                "order": 7,
                "block": "Solicitud",
                "label": "Plazo",
                "source": "Cotizador",
                "value": 36,
                "value_label": "36 meses",
                "bin": "b36",
                "bin_label": "Desde 36",
                "points": 1.3,
                "max_points": 2,
                "imputed": false,
                "imputed_reason": null
            },
            "guarantee": {
                "order": 8,
                "block": "Solicitud",
                "label": "Garantía adicional",
                "source": "Expediente (aval obligatorio)",
                "value": "AVAL",
                "value_label": "AVAL",
                "bin": "AVAL",
                "bin_label": "AVAL",
                "points": 3.5,
                "max_points": 3.5,
                "imputed": false,
                "imputed_reason": null
            },
            "applicant_age": {
                "order": 9,
                "block": "Perfil",
                "label": "Edad del solicitante",
                "source": "RFC",
                "value": 41,
                "value_label": "41 años",
                "bin": "b30",
                "bin_label": "Desde 30",
                "points": 0.5,
                "max_points": 1,
                "imputed": false,
                "imputed_reason": null
            },
            "state_risk_zone": {
                "order": 10,
                "block": "Ubicación",
                "label": "Estado / zona de riesgo",
                "source": "CSF (con CIEC) / domicilio fiscal de onboarding (sin CIEC)",
                "value": "JALISCO",
                "value_label": "JALISCO",
                "bin": "BAJO",
                "bin_label": "Zona BAJO",
                "points": 3,
                "max_points": 3,
                "imputed": false,
                "imputed_reason": null
            },
            "office_possession": {
                "order": 11,
                "block": "Ubicación",
                "label": "Posesión del consultorio",
                "source": "Formulario (renta)",
                "value": "RENTADA_TERCERO",
                "value_label": "Renta $45,000/mes",
                "bin": "RENTADA_TERCERO",
                "bin_label": "RENTADA TERCERO",
                "points": 0,
                "max_points": 1.5,
                "imputed": false,
                "imputed_reason": null
            }
        },
        "abortives": {
            "payment_times": {
                "activated": true,
                "hit": false,
                "value": 7.34,
                "rule": 2.5
            },
            "debt_relief": {
                "activated": true,
                "hit": false,
                "value": false,
                "rule": null
            },
            "worst_mop": {
                "activated": false,
                "hit": false,
                "value": 2,
                "rule": 4
            }
        },
        "reviews": {
            "tax_compliance": {
                "activated": true,
                "hit": null,
                "value": null,
                "rule": {
                    "1": "negative"
                }
            },
            "applicant_age": {
                "activated": true,
                "hit": false,
                "value": 41,
                "rule": {
                    "1": 18,
                    "2": 65
                }
            }
        }
    },
    "created_at": "2026-02-09T18:13:00.374394",
    "updated_at": "2026-02-09T17:21:43.611198",
    "loan_application_id": "88806c9e-4a9d-44a2-8f02-0329f188fab1",
    "id_model": null,
    "active": true,
    "is_previous_client": null,
    "financed_services": null,
    "resource_use_description": "Capital de trabajo",
    "resource_use_activity": "Produccion de alimentos",
    "resource_use_business_sector": null,
    "resource_uses": "Capital de trabajo",
    "abortives_raw_data": {
        "sales": {
            "sales_volume": 308818088.71,
            "government_sales": 0,
            "income_variation_bim": 0.5134177411495039,
            "income_variation_trim": 0.6104360794075071,
            "income_variation_monthly": 3.98560615750485
        },
        "state": "MEXICO",
        "seniority": {
            "seniority": 43,
            "seniority_activity": 43
        },
        "blacklists": {
            "blacklist_status": false,
            "blacklisted_counterparties": 0
        },
        "tax_return": {
            "equity": 23402019,
            "tax_return_exist": false
        },
        "concentration": {
            "client_concentration": 72,
            "top_2_client_concentration": 72
        },
        "credit_bureau": {
            "credit_bureau_history": 3707576
        },
        "tax_compliance": {
            "tax_compliance": "negative"
        },
        "canceled_invoice": {
            "issued_canceled_invoice": 0.02,
            "received_canceled_invoice": 0.07
        },
        "payment_capacity": {
            "payment_capacity": 300286338.278012
        },
        "cash_transaction_risk": {
            "cash_transaction_risk": 0.01
        },
        "supplier_concentration": {
            "supplier_concentration": 24.28,
            "top_2_supplier_concentration": 38.85
        },
        "shareholder_or_pfae_age": {
            "shareholder_or_pfae_age": 34.43394934976044
        },
        "credit_bureau_accredited": {
            "mops_matrix": false,
            "fiscal_credits": 0,
            "overdue_balance": 0,
            "percentage_mops_1": 100,
            "credit_bureau_history": 2086675,
            "debt_restructuring_bankruptcies_dations": false
        },
        "fiscal_status_certificate": {
            "zone": "52945",
            "non_preponderant_activity_excluded": "713941"
        },
        "credit_bureau_shareholder_or_pf": {
            "mops_matrix": false,
            "overdue_balance": 0,
            "percentage_mops_1": 100,
            "debt_restructuring_bankruptcies_dations": false
        }
    },
    "company_summary": "El acreditado no cuenta con score Buró de Crédito; el aval presenta score Buró de Crédito de 745, con historial sin atrasos pero con cuatro cuentas con historia negativa y alto volumen de consultas recientes. En SIGER RPC, la empresa está activa, constituida recientemente como S.A. de C.V., sin incidencias legales. Operativamente, muestra antigüedad limitada, sin empleados ni capital reportado, gastos superiores a ingresos y opinión de cumplimiento negativa. No existen alertas de listas negras, pero se observa alta utilización de líneas de crédito y búsqueda activa de financiamiento. El score de crédito asignado por el modelo Lendia es B (626), sin monto autorizado; el modelo externo no otorga score.",
    "id": "148ba934-547e-4568-b542-e2544c25bbc4",
    "general_data": {
        "company_name": "Impulsora Comercial Mexicana",
        "web_page": "mipaginaweb.com",
        "linkedin": null,
        "facebook": null,
        "instagram": null,
        "x_twitter": null
    },
    "credit_use": "Capital de trabajo",
    "id_application": 2744,
    "date_loan_application": "2026-02-24T00:46:36.792476",
    "status_loan_application": {
        "id": "476a5ba3-f9cc-4fc7-999a-c3fa93c484e7",
        "name": "Emisión Doctos Valor",
        "code": "CSEVD"
    },
    "date_authorization": null
}
